import { OktaAuth } from '@okta/okta-auth-js';
import { config } from '../config/env';

// Get configuration from runtime or build-time config
const OKTA_ISSUER = config.oktaIssuer;
const OKTA_CLIENT_ID = config.oktaClientId;
const REDIRECT_URI = `${window.location.origin}/callback`;

if (!OKTA_ISSUER || !OKTA_CLIENT_ID) {
  console.error('Missing Okta configuration. Please set ADMIN_UI_OKTA_ISSUER and ADMIN_UI_OKTA_CLIENT_ID');
}

// Create Okta Auth instance for SPA
export const oktaAuth = new OktaAuth({
  issuer: OKTA_ISSUER,
  clientId: OKTA_CLIENT_ID,
  redirectUri: REDIRECT_URI,
  scopes: [
    'openid',
    'profile',
    'email',
    'okta.aiAgents.read',
    'okta.aiAgents.manage',
    'okta.apps.read',
    'okta.apps.manage',
    'okta.users.read'
  ], // OIDC scopes + Management API scopes for admin operations
  pkce: true, // Enable PKCE for public client
  tokenManager: {
    autoRenew: true,
    storage: 'sessionStorage' // More secure than localStorage
  }
});
